// Display helpers shared by the merchant pages (French conventions).

const PLAN_LABELS = {
  trial: 'Essai gratuit',
  essentiel: 'Essentiel',
  pro: 'Pro',
  starter: 'Essentiel',
};

/** "trial" → "Essai gratuit", "pro" → "Pro". */
export const planLabel = (plan) => PLAN_LABELS[plan] || (plan ? plan.charAt(0).toUpperCase() + plan.slice(1) : '');

/** 29 → "29 €", 29.5 → "29,50 €" (non-breaking space, as in French). */
export const formatEuros = (amount) => {
  const n = Number(amount) || 0;
  const digits = Number.isInteger(n) ? 0 : 2;
  return `${n.toLocaleString('fr-FR', { minimumFractionDigits: digits, maximumFractionDigits: digits })} €`;
};
